import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Button } from '../../../../global/button/Button'
import { Text } from '../../../Typography/Typography'
import { DialogModal } from '../DialogModal'
import type { CommonModalProps } from '../types'

import styles from './RadioModalDesktop.module.scss'

interface RadioModalProps extends PropsWithChildren<CommonModalProps> {
  description?: React.ReactNode
  options: React.ReactNode[]
  isLoading?: boolean
  renderFooter?(props: RadioModalProps): React.ReactNode[]
}

export const RadioModalDesktop: React.FC<RadioModalProps> = (props) => {
  const { size, title, isLoading = false, onClose, renderFooter } = props

  const { t } = useTranslation()

  return (
    <DialogModal.Wrapper
      isLoading={isLoading}
      header={<DialogModal.Header title={title} />}
      renderFooter={({ onClose }) =>
        renderFooter?.({ ...props, onClose }) || [
          <Button appearance='primary' onClick={onClose}>
            {t('Cancel')}
          </Button>,
        ]
      }
      size={size}
      onClose={onClose}
    >
      <Body {...props} />
    </DialogModal.Wrapper>
  )
}

const Body: React.FC<RadioModalProps> = (props) => {
  const { description, options = [], children } = props

  return (
    <DialogModal.Body>
      {description && (
        <div
          className={classNames(styles.description, {
            [styles.noOptions]: !options.length,
          })}
        >
          <Text isParagraph>{description}</Text>
        </div>
      )}
      {!!options.length && (
        <div className={styles.options}>
          {options.map((x, index) => (
            <div className={styles.option} key={index}>
              {x}
            </div>
          ))}
        </div>
      )}
      {children && <div>{children}</div>}
    </DialogModal.Body>
  )
}
